import { search } from "../../BaseRepositoryComponents";

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function find({
  empresaCnpj,
  path,
  include,
  orWhere = {},
  orWhereTranslate = {},
  where = {},
  whereTranslate = {},
  perPage = "250",
  page = 0,
  sort = "",
  fields = {},
  between = "",
  urlObjects = null,
  rawUrl = "",
}) {
  const completePath = `${process.env.REACT_APP_URL_API_ERP}/erp/${path}`;
  let queryOrWhere = "";
  if (orWhere) {
    Object.keys(orWhere).forEach((key) => {
      queryOrWhere += `&orwhere[${key}]=${orWhere[key]}`;
    });
  }

  let queryOrWhereTranslate = "";
  if (orWhereTranslate) {
    Object.keys(orWhereTranslate).forEach((key) => {
      queryOrWhereTranslate += `&orWhereTranslate[${key}]=${orWhereTranslate[key]}`;
    });
  }

  let queryWhere = "";
  if (where) {
    Object.keys(where).forEach((key) => {
      queryWhere += `&where[${key}]=${where[key]}`;
    });
  }

  let queryWhereTranslate = "";
  if (whereTranslate) {
    Object.keys(whereTranslate).forEach((key) => {
      queryWhereTranslate += `&whereTranslate[${key}]=${whereTranslate[key]}`;
    });
  }

  let queryFields = "";
  Object.keys(fields).forEach((key) => {
    queryFields += `&fields[${key}]=${fields[key]}`;
  });

  let queryUrlObjects = "";
  if (urlObjects && typeof urlObjects === "object") {
    Object.keys(urlObjects).forEach((key) => {
      if (urlObjects[key]) queryUrlObjects += `&${key}=${urlObjects[key]}`;
    });
  }

  const queryWhereConditions = `${queryWhere}${queryWhereTranslate}${queryOrWhere}${queryOrWhereTranslate}`;
  return search(
    !rawUrl
      ? `${completePath}?empresa_cnpj=${empresaCnpj}${queryWhereConditions}${
          include ? `&include=${include}` : ""
        }&per_page=${perPage}${page ? `&page=${page}` : ""}${
          sort ? `&sort=${sort}` : ""
        }${queryFields}${between ? `&${between}` : ""}${
          queryUrlObjects ? queryUrlObjects : ""
        }`
      : `${completePath}?empresa_cnpj=${empresaCnpj}&${rawUrl}${queryWhereConditions}&per_page=${perPage}${queryUrlObjects}`,
    "GET",
    headers
  );
}
